// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__29ARY","half":"styles_half__1NPcW","leftHalf":"styles_leftHalf__18mnD","rightHalf":"styles_rightHalf__3E9dj"};